import CryptoJS from "crypto-js";
export async function encryptMessage(message, key, iv) {
  try {
    const encrypted = CryptoJS.AES.encrypt(message, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString(); // Encrypted string in Base64 format
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
}

export async function encryptPayload(payload, key, iv) {
  const data =
    payload.name +
    payload.message_title +
    payload.message_body +
    payload.sms_reference_id;
  try {
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString(); // Encrypted string in Base64 format
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
}
